import { useCallback, useEffect, useRef, useState } from "react";

export function useLocalStorage(key) {
   const [value, setValue] = useState(() => {
      const value = window.localStorage.getItem(key)
      return value;
   })
   useEffect(() => {
      window.localStorage.setItem(key, value)
   }, [value, key])
   return [value, setValue]
}

export function useShowBackToTopBtn() {
   const [value, setValue] = useState(false)
   const timeRef = useRef();
   const scrollListener = useCallback(() => {
      clearTimeout(timeRef.current);
      timeRef.current = setTimeout(() => {
         setValue(window.scrollY > 300);
      }, 300);
   }, [setValue]);
   useEffect(() => {
      document.addEventListener("scroll", scrollListener);
      return () => {
         document.removeEventListener("scroll", scrollListener);
      };
   }, [scrollListener]);
   return [value]
}

export function useDocumentTitle(title){
   useEffect(()=>{
      document.title = title;
   },[title])
}

export function useImageIntersectionObserver(obj) {
   const observerRef = useRef(
      new IntersectionObserver((entries) => {
         entries.forEach((entry) => {
            const { target, intersectionRatio } = entry;

            if (intersectionRatio > 0) {
               const _target = target;

               _target.src = _target.dataset["src"] ?? "";
               _target.onload = () => {
                  _target.style.opacity = "1";
               };

               observerRef.current.unobserve(_target);
            }
         });
      })
   );
   useEffect(() => {
      const curObserverRef = observerRef.current;
      Array.from(document.getElementsByClassName("refImg")).forEach((img) => curObserverRef.observe(img));
      return () => {
         curObserverRef.disconnect();
      };
   }, [obj]);

   return observerRef;
}